export default `
  mutation adminSetUserActive($userId: String!, $email: String, $isActive: Boolean!) {
    adminSetUserActive(userId: $userId, email: $email, isActive: $isActive) {
      id
      isActive
    }
  }
`
